import DefaultLayout from './default-layout'

DefaultLayout.install = Vue => {
  Vue.component(DefaultLayout.name, DefaultLayout)
}

export {DefaultLayout}



// WEBPACK FOOTER //
// ./src/components/layout/index.js